import { PropsOf } from '@emotion/react'
import { styled } from '@mui/material'

// Content styles for displaying stored rich-text HTML (previously from quill's snow stylesheet).
const StyledSpanWithQuillOverrides = styled('span')(({ theme: { palette } }) => ({
  '& ul': { listStyle: 'disc', paddingLeft: '1.5em', margin: '4px 0' },
  '& ol': { listStyle: 'decimal', paddingLeft: '1.5em', margin: '4px 0' },
  '& blockquote': {
    borderLeft: `4px solid ${palette.border.subtle}`,
    paddingLeft: '1em',
    margin: '4px 0',
    color: palette.text.default,
  },
  '& a': { color: palette.text.brand.default, textDecoration: 'underline' },
  '& img': { maxWidth: '100%', maxHeight: '320px', height: 'auto', objectFit: 'contain' },
  '& .mention': {
    color: palette.text.brand.default,
    background: palette.bg.brand.muted,
    padding: '1px 4px',
    borderRadius: '4px',
  },
  '& .mention[data-error="true"]': {
    color: palette.text.danger.onDangerMuted,
    background: palette.bg.danger.muted,
  },
}))

const StyledQuillEditor = styled('span')(() => ({}))

// Intentionally no `ql-editor` class — that selector is reserved for the editable input.
export const SpanWithQuillStyles = (props: PropsOf<typeof StyledSpanWithQuillOverrides>) => {
  const { children, ...restProps } = props
  return (
    <StyledSpanWithQuillOverrides>
      <StyledQuillEditor {...restProps}>{children}</StyledQuillEditor>
    </StyledSpanWithQuillOverrides>
  )
}
